var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    width: 24,
    height: 24,
    color: "#010109e6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-637b8a2bf95e86b59c57a23b-1{fill:none;stroke:currentColor;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-637b8a2bf95e86b59c57a23b-1",
    d: "M18.34,4.21A4.86,4.86,0,0,0,14,6.14H10A4.86,4.86,0,0,0,5.66,4.21,5,5,0,0,0,1.25,9.28v7A3.5,3.5,0,0,0,8,17.61c.42-1.05.94-2.37,1.42-3.66h5.16c.48,1.29,1,2.61,1.42,3.66a3.5,3.5,0,0,0,6.75-1.29v-7A5,5,0,0,0,18.34,4.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-637b8a2bf95e86b59c57a23b-1",
    d: "M18.84,12h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-637b8a2bf95e86b59c57a23b-1",
    d: "M18.84,8.09h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-637b8a2bf95e86b59c57a23b-1",
    d: "M20.79,10.05h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-637b8a2bf95e86b59c57a23b-1",
    d: "M16.89,10.05h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-637b8a2bf95e86b59c57a23b-1",
    d: "M7.11,12h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-637b8a2bf95e86b59c57a23b-1",
    d: "M7.11,8.09h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-637b8a2bf95e86b59c57a23b-1",
    d: "M9.07,10.05h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-637b8a2bf95e86b59c57a23b-1",
    d: "M5.16,10.05h0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIcon);
export default __webpack_public_path__ + "static/media/design-icon.858447e0d18f19fa164735acccce841c.svg";
export { ForwardRef as ReactComponent };